export const COMPONENT_NAME_WCAG_SUMMARY = 'WCAGSummary';
export const COMPONENT_NAME_WCAG_SUMMARY_SKELETON = 'WCAGSummarySkeleton';
